import { z } from 'zod';

const localizedStringSchema = z.object({
  en: z.string(),
  de: z.string().optional(),
  es: z.string().optional(),
  fr: z.string().optional(),
  pt: z.string().optional(),
  uk: z.string().optional(),
});

const locationSchema = z.object({
  longitude: z.number(),
  latitude: z.number(),
  countryCode: z.string(),
  city: localizedStringSchema.required(),
});

const clusterSchema = z.object({
  id: z.string(),
  hostname: z.string(),
  location: locationSchema,
  protocols: z.array(
    z.object({ port: z.number(), protocol: z.enum(['OpenVPN_TCP', 'IKEv2', 'Hysteria2', 'WireGuard']) }),
  ),
  loadIndex: z.number(),
  capacity: z.number(),
});

const shortcutSchema = z.object({
  id: z.string(),
  title: localizedStringSchema,
  images: z.object({ icon: z.string() }),
  shortcuts_access: z.enum(['SHORTCUTS_ACCESS_FREE', 'SHORTCUTS_ACCESS_PREMIUM']),
  clusters: z.array(clusterSchema),
  description: localizedStringSchema.optional(),
});

const shortcutGroupSchema = z.object({
  group_id: z.string(),
  slug: z.string(),
  title: localizedStringSchema,
  description: localizedStringSchema.optional(),
  images: z.object({ header: z.string().optional() }),
  shortcuts_access: z.enum(['SHORTCUTS_ACCESS_PREMIUM', 'SHORTCUTS_ACCESS_FREE']),
  shortcuts: z.array(shortcutSchema),
  payload: z.object({}).nullable(),
  shortcut_type: z.enum(['SHORTCUTS_TYPE_STREAMING', 'SHORTCUTS_TYPE_COUNTRY_PICKER', 'SHORTCUTS_TYPE_DEFAULT']),
});

const optimalLocationSchema = z.object({
  id: z.string(),
  title: localizedStringSchema,
  description: localizedStringSchema.optional(),
  images: z.object({ icon: z.string().optional() }),
  shortcuts_access: z.enum(['SHORTCUTS_ACCESS_PREMIUM', 'SHORTCUTS_ACCESS_FREE']),
  cluster: clusterSchema.omit({ protocols: true }),
});

export const routerSetupOptionsResponseSchema = z.object({
  cache_ttl: z.number(),
  shortcut_groups: z.array(shortcutGroupSchema),
  optimal_location: optimalLocationSchema,
});
export type RouterSetupOptionsResponse = z.infer<typeof routerSetupOptionsResponseSchema>;
export type ShortcutsAccess = z.infer<typeof shortcutGroupSchema>['shortcuts_access'];
